import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Form,
  Input,
  Typography
} from 'antd';

import { login as doLogin } from '../../api/modules/auth';
import INTERNAL_LINKS from '../../enum/InternalLinks';

const { Title } = Typography;

const LoginPage = ({ history, location }) => {
  const [showAlert, setAlert] = useState(null);
  const [isAuthenticated] = useState(window.localStorage.access_token !== undefined);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (isAuthenticated === true) {
      history.push(INTERNAL_LINKS.HOME);
    }
  });

  const login = async (data) => {
    setAlert(null);
    setLoading(true);
    const response = await doLogin(data);
    setAlert(response);
    setLoading(false);
    if (response === true) {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  }
  return (<div>
    <Title level={3}>Login Form / Formulario de Inicio de Sesión</Title>
    <Form
      layout="vertical"
      onFinish={(data) => {
        login(data);
      }}
    >
      <Form.Item
        label="Username / Nombre de usuario"
        name="username"
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Password / Contraseña"
        name="password"
        rules={[{ required: true }]}
      >
        <Input.Password />
      </Form.Item>
      <Form.Item>
        <Button type="primary" loading={loading} htmlType="submit">Login / Iniciar Sesión</Button>
      </Form.Item>
    </Form>
    {
      showAlert === true ?
        <Alert
          showIcon
          message="Welcome / Bienvenido"
          description="Please wait... / Por favor espere..."
          type="success"
        /> :
        showAlert === false ?
          <Alert
            showIcon
            message="Error"
            description="the credentials provided are incorrect"
            type="error" />
          : <></>
    }
  </div>);
};

export default LoginPage;